<div class="dropdown">
  <div class="dropdown-header" fxLayout="row" fxLayoutAlign="space-between center">
    <div>
      <div class="dropdown-heading">{{ 'HISTORY' | translate }}</div>
      <div class="dropdown-subheading">
        {{ 'HAVE_N_NEW_HISTORY' | translate : { count: historyData.length } }}
      </div>
    </div>
  </div>

  <div class="dropdown-content">
    <div *ngIf="!loader" class="flex flex-row justify-center my-2">
      <mat-spinner diameter="30"></mat-spinner>
    </div>
    <a
      (click)="setLinkInfo(history)"
      *ngFor="let history of historyData; trackBy: trackById"
      [class.read]="history.read"
      [routerLink]="[history.path]"
      class="history"
      fxLayout="row"
      fxLayoutAlign="start center"
      matRipple>
      <!-- <ic-icon [icon]="history.icon" [ngClass]="history.colorClass" class="history-icon" fxFlex="none" size="24px">
      </ic-icon> -->

      <img
        [src]="history.icon"
        [ngClass]="history.colorClass"
        class="history-icon"
        fxFlex="none" />
      <!-- <i class="fa {{history.icon}} fa-2x"></i> -->

      <div fxFlex="auto">
        <div class="history-label">{{ history.HistoryName }}</div>
        <div class="history-description">
          {{ history.enterdate | date : 'd MMMM, y' }}
        </div>
      </div>
      <!-- <mat-icon [icIcon]="icChevronRight" class="history-chevron" fxFlex="none"></mat-icon> -->
    </a>
  </div>
</div>
